/**
 * @description
 */

import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

interface IInput {
    questionId: string;
}

interface IOutput {
    status: boolean;
    data: {
        commentVersion: number;
    };
}

export const getCommentVersion = (data: IInput): Promise<IOutput> => {
    return fetchData(Api.GET_COMMENT_VERSION, data).then((res: IOutput) => {
        return res;
    });
};

export const getCommentVersionSync = fetchDataSync(getCommentVersion);
